module.exports = __webpack_public_path__ + "toGroom-we-y-w.9130ea99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-y-w.jpg
// module id = rsBz
// module chunks = 0